import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import React from 'react'
import styled from 'styled-components'

const Button = styled.button`
  padding: 0.25rem;
  border: 1px solid #666666;
  background-color: #000000;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.75rem;
  flex: 1;

  &:hover {
    background-color: #444444;
    border-color: #888888;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

interface ScrollButtonProps {
  direction: 'left' | 'right'
  onClick: () => void
  style?: React.CSSProperties
}

export const ScrollButton: React.FC<ScrollButtonProps> = ({
  direction,
  onClick,
  style,
}) => {
  return (
    <Button onClick={onClick} style={style}>
      {direction === 'left' ? (
        <ChevronLeftIcon width={16} height={16} />
      ) : (
        <ChevronRightIcon width={16} height={16} />
      )}
    </Button>
  )
}
